export const labels = {
	title: {
		label: "Label.MobileCreator.Price.Title",
		default: "Price details",
	},
	close: {
		label: "Label.MobileCreator.Price.Close",
		default: "Close",
	},
	total: {
		label: "Label.MobileCreator.Price.Total",
		default: "Total",
	},
};
